import {LoadingButton} from '@mui/lab';
import {Button} from '@mui/material';
import {get} from 'lodash';
import {FC, Fragment, useRef} from 'react';
import {useRecoilValue} from 'recoil';
import {FiltersSetDto} from '../../../../global/api';
import {useFiltersSetsRefresh, usePostFiltersSets} from '../../../../global/services/filters-sets';
import {authState} from '../../../../store/auth/atoms';
import {filtersToEntries} from '../../helpers/filters-to-entries';
import {
  contractTableFiltersAddModalClose,
  useContractTableFiltersAddModalStore,
} from '../../stores/contract-table-filters-add-modal.store';
import {useContractsTableFiltersStore} from '../../stores/contracts-table-filters.store';
import {ContractModal} from '../contract-modal';
import {ContractsTableFiltersModalForm, ContractsTableFiltersModalFormRef} from './contracts-table-filters-moda-forml';

const DEFAULT_VALUES = {
  name: '',
};

export const ContractsTableCreateFiltersModal: FC = () => {
  const ref = useRef<ContractsTableFiltersModalFormRef>(null);
  const open = useContractTableFiltersAddModalStore((s) => s.open);
  const {user} = useRecoilValue(authState);
  const {mutate, loading} = usePostFiltersSets();
  const refreshFiltersSets = useFiltersSetsRefresh();
  const filters = useContractsTableFiltersStore((s) => s.filters);

  const handleClose = () => {
    ref.current?.form.reset(DEFAULT_VALUES);
    contractTableFiltersAddModalClose();
  };

  const afterMutateCallback = () => {
    refreshFiltersSets();
    handleClose();
  };

  const handleFormSubmit = () => {
    ref.current?.form.handleSubmit(async (data) => {
      const requestData: FiltersSetDto = {
        name: data.name,
        filters: JSON.stringify(filtersToEntries(filters)),
        filterType: 'CONTRACTS',
        userUid: get(user, 'uid', ''),
        createdDate: new Date().toISOString(),
        createdBy: get(user, 'email', ''),
      };
      mutate([requestData], afterMutateCallback);
    })();
  };

  return (
    <ContractModal
      title="Сохранение фильтра"
      open={open}
      footer={
        <Fragment>
          <Button variant="outlined" color="error" onClick={handleClose}>
            Отменить
          </Button>
          <LoadingButton variant="contained" onClick={handleFormSubmit} loading={loading}>
            Добавить
          </LoadingButton>
        </Fragment>
      }
    >
      <ContractsTableFiltersModalForm ref={ref} defaultValues={DEFAULT_VALUES} filters={filters} />
    </ContractModal>
  );
};
